import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    //elevate ribbon so statusBar is under it.
    ribbonator: {
        '&>div': {zIndex: 1200}, //a bunch, but under MUI drawer
    },
}));